import {
  AfterViewInit,
  ComponentRef,
  DestroyRef,
  Directive,
  ElementRef,
  Input,
  Renderer2,
  ViewContainerRef,
  booleanAttribute,
  inject,
} from '@angular/core';

import { UpgradeTagComponent } from '../components/upgrade-tag/upgrade-tag.component';

@Directive({
  selector: '[laUpgradeDiamond]',
  standalone: true,
})
export class UpgradeDiamondDirective implements AfterViewInit {
  @Input({ alias: 'laUpgradeDiamond', transform: booleanAttribute }) showUpgradeDiamond = false;

  private readonly hostElementRef = inject(ElementRef<HTMLElement>);
  private readonly renderer = inject(Renderer2);
  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly destroyRef = inject(DestroyRef);

  private componentRef?: ComponentRef<UpgradeTagComponent>;
  private readonly interactiveTargetSelector = 'button, [role="button"], [role="combobox"]';

  ngAfterViewInit(): void {
    if (!this.showUpgradeDiamond || this.componentRef) {
      return;
    }

    const targetElement = this.resolveTargetElement();
    const isOptionContext = !!targetElement.closest('[role="option"]');

    this.applyBaseLayout(targetElement);
    if (isOptionContext) {
      this.applyOptionLayout(targetElement);
    }

    this.componentRef = this.viewContainerRef.createComponent(UpgradeTagComponent);
    this.renderer.addClass(this.componentRef.location.nativeElement, 'la-no-hover');
    this.renderer.appendChild(targetElement, this.componentRef.location.nativeElement);

    this.destroyRef.onDestroy(() => {
      this.componentRef?.destroy();
      this.componentRef = undefined;
    });
  }

  private resolveTargetElement(): HTMLElement {
    const hostElement = this.hostElementRef.nativeElement;
    return (hostElement.querySelector(this.interactiveTargetSelector) as HTMLElement | null) ?? hostElement;
  }

  private applyBaseLayout(targetElement: HTMLElement): void {
    this.renderer.setStyle(targetElement, 'display', 'flex');
    this.renderer.setStyle(targetElement, 'align-items', 'center');
    this.renderer.setStyle(targetElement, 'gap', '8px');
  }

  private applyOptionLayout(targetElement: HTMLElement): void {
    const parentElement = targetElement.parentElement;
    if (parentElement) {
      this.renderer.setStyle(parentElement, 'display', 'block');
      this.renderer.setStyle(parentElement, 'width', '100%');
    }
  }
}
